/* eslint-disable @typescript-eslint/no-explicit-any */
import backendApi from "./backendApi";
import { showSnackbar } from "./snackbar.service";
import { IUserSettings } from "../types/userSettings";

const routePrefix = "user-preferences";

export default {
  async get(): Promise<IUserSettings | null> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/get`);
      return result.data;
    } catch (error: any) {
      return null;
    }
  },
  async set(update: Partial<IUserSettings>): Promise<IUserSettings | null> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/set`, update);
      return result.data;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not save your settings."
        );
      }
      return null;
    }
  },
};

